// src/components/home/VideoSection.jsx
import React, { useState } from "react";
import { Container } from "react-bootstrap";
import { FaPlay, FaTimes } from "react-icons/fa";
import "../../../../assets/css/customer/home/videoSection/VideoSection.css";
import videoimg from "../../../../assets/images/home/videoimg.jpeg";
const VideoSection = () => {
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);

  const handlePlayVideo = () => {
    setIsVideoPlaying(true);
  };

  const handleCloseVideo = () => {
    setIsVideoPlaying(false);
  };

  return (
    <>
      {/* Video Section */}
      <section className="video-section">
        <div className="video-background">
          <img
            src={videoimg}
            alt="Organic Vegetables"
            className="video-bg-image"
          />
          <div className="video-overlay"></div>
        </div>

        <Container>
          <div className="video-content">
            {/* Animated Play Button Circle with Rotating Text */}
            <div className="play-button-wrapper" onClick={handlePlayVideo}>
              <div className="play-button-circle">
                {/* Rotating Green Rings */}
                <div className="circle-ring ring-1"></div>
                <div className="circle-ring ring-2"></div>
                <div className="circle-ring ring-3"></div>

                {/* SVG Circular Text - Continuously Rotating */}
                <div className="circular-text-wrapper">
                  <svg viewBox="0 0 200 200" className="circular-text-svg">
                    <defs>
                      <path
                        id="circlePath"
                        d="M 100, 100 m -75, 0 a 75,75 0 1,1 150,0 a 75,75 0 1,1 -150,0"
                      />
                    </defs>
                    <text className="circular-text">
                      <textPath href="#circlePath" startOffset="0%">
                        PLAY VIDEO • EXPLORE FARM • PLAY VIDEO • EXPLORE FARM •
                      </textPath>
                    </text>
                  </svg>
                </div>

                {/* Center Play Button - Fixed */}
                <div className="play-button-center">
                  <FaPlay className="play-icon" />
                </div>
              </div>
            </div>

            {/* Text Content */}
            <div className="video-text-content">
              <h2 className="video-title">
                <span className="title-line">Organic Vegetables</span>
                <span className="title-line">in Our Store</span>
              </h2>
            </div>
          </div>
        </Container>

        {/* Oval/Round Shape Bottom */}
        <div className="oval-shape">
          <svg
            viewBox="0 0 1440 200"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
          >
            <path
              fill="#ffffff"
              d="M0,120 Q360,200 720,180 Q1080,160 1440,120 L1440,200 L0,200 Z"
            />
          </svg>
        </div>
      </section>

      {/* Video Modal with Close Button */}
      {isVideoPlaying && (
        <div className="video-modal" onClick={handleCloseVideo}>
          <div
            className="video-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button on Video */}
            <button className="close-video-btn" onClick={handleCloseVideo}>
              <FaTimes />
            </button>

            <div className="video-container">
              <iframe
                width="100%"
                height="100%"
                src="https://www.youtube.com/embed/dQw4w9WgXcQ?autoplay=1"
                title="Farm Video"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default VideoSection;
